import { createAction } from '@reduxjs/toolkit'
import { SegmentList } from 'features/Programs/Shared/helperFunctions'
import { ReportParams, ReportType } from './types'
import { YearMonth } from 'core-system/MonthRangePicker/DropdownCalendar'

const changeSelectedSegments = createAction<SegmentList[]>(
  'reports/changeSelectedSegments'
)

const changeReportType = createAction<ReportType>('reports/changeReportType')

const changeStartDate = createAction<YearMonth>('reports/changeStartDate')

const changeEndDate = createAction<YearMonth>('reports/changeEndDate')

const getOverallReport = createAction<ReportParams>('reports/getOverallReport')

const getRemainingReports = createAction<ReportParams>(
  'reports/getRemainingReports'
)

const getProgramAllocationReport = createAction<ReportParams>(
  'reports/getProgramAllocationReport'
)

const generateAiReport = createAction<{ prompt: string }>(
  'reports/generateAiReport'
)

const clearAiReportError = createAction('reports/clearAiReportError')

export const reportsActions = {
  changeSelectedSegments,
  changeReportType,
  changeStartDate,
  changeEndDate,
  getOverallReport,
  getRemainingReports,
  getProgramAllocationReport,
  generateAiReport,
  clearAiReportError,
}
